<script setup>
import { useIdleStore } from '~/stores/idle'
const idle = useIdleStore()

const emit = defineEmits(['stay', 'logout'])
</script>

<template>
  <Dialog
    v-model:visible="idle.show"
    modal
    :closable="false"
    :dismissableMask="false"
    header="Are you still there?"
    :style="{ width: '420px' }"
  >
    <div class="space-y-3">
      <p class="text-slate-700">
        For security, we’ll sign you out in <b>{{ idle.secondsLeft }}</b> seconds if there’s no activity.
      </p>

      <div class="flex justify-end gap-2 pt-2">
        <Button label="Stay signed in" icon="pi pi-check" @click="emit('stay')" />
        <Button label="Logout" severity="secondary" icon="pi pi-sign-out" @click="emit('logout')" />
      </div>
    </div>
  </Dialog>
</template>
